<template>
  <div class="indexer mb-1" v-if="loaded">
    <drop-down
      class="mb-1"
      id="drop-down-resolver-drop-down"
      label="Specify the aspect:"
      v-model="selectedItem"
      :items="items"
      :value-as-key="false"
    />
    <div class="d-flex">
      <button class="btn btn-primary" type="button" @click="resolveClicked">
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import templates from "@/services/sharedo/templatesService";
import graph from "@/services/sharedo/graphService";
import { ascending } from "@/util/sort";

export default {
  data: function () {
    return {
      items: [],
      selectedItem: null,
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      currentTemplates: (state) => state.currentTemplates,
    }),
  },
  methods: {
    load: async function () {
      const template = await templates.getOne(this.currentTemplates[0]);
      const roleAspects = await graph.getRoleAspects(
        template.contextTypeSystemName
      );

      const items = roleAspects.map((aspect) => ({
        label: aspect.name,
        value: aspect.systemName,
      }));

      items.sort(ascending((item) => item.label));

      this.items = items;
      this.selectedItem = items[0].value;
      this.loaded = true;
    },
    resolveClicked: function () {
      this.$emit("resolve", this.selectedItem);
    },
  },
  mounted: async function () {
    await this.load();
  },
};
</script>